module.exports = __webpack_public_path__ + "img/Bildschirmfoto_2019-09-03_um_10.00.11.fd0332bd.png";